const BASE = ['ai_chat'];

export const AI_CHAT_KEYS = {
  getAiChatSessionQueryKey: (sessionId: number) =>
    [...BASE, 'session', sessionId] as const,
  getAllAiChatSessionQueryKey: () => [...BASE, 'allSession'] as const,
  getGeneratedFileExports: () => [...BASE, 'fileExports'] as const,
};
